import translations from "./translations";
import {Table} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import React, {useMemo} from "react";
import useCustomTranslation from "core/customTranslation";

const TableParamsDD = ({device}) => {
    const {t: _TC} = useCustomTranslation(translations);

    const {pretty, groups, parsedKeys} = useMemo(() => {
        const raw = device && (device.device_params ?? device.params ?? device.deviceParams);
        if (!raw) return {pretty: "(no parameters)", groups: null, parsedKeys: null};
        try {
            const obj = typeof raw === "string" ? JSON.parse(raw) : raw;
            const pretty = JSON.stringify(obj, null, 2);

            const groupNames = ["A", "B", "A->B", "B->A"];
            const hasGroups = groupNames.every((g) => obj && Object.prototype.hasOwnProperty.call(obj, g));
            const groups = hasGroups ? groupNames.map((g) => ({name: g, ...obj[g]})) : null;

            const parsedKeys = Object.keys(obj || {});

            return {pretty, groups, parsedKeys};
        } catch (e) {
            return {pretty: String(raw), groups: null, parsedKeys: null};
        }
    }, [device]);

    return (
        <>
            {groups ? (
                <Table bordered responsive onAnimationStart className="mb-0 text-center h-50">
                    <thead>
                        <tr>
                            <th></th>
                            <th>{_TC("devicemeasure")} 1</th>
                            <th>{_TC("devicemeasure")} 2</th>
                            <th>{_TC("devicemeasure")} 3</th>
                            <th>{_TC("devicemeasure")} 4</th>
                            <th>{_TC("devicetotal")}</th>
                            <th>{_TC("devicegroup")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {groups.map((g) => {
                            const p1 = Array.isArray(g.p1) ? g.p1 : [];
                            const p2 = Array.isArray(g.p2) ? g.p2 : [];
                            const total = g.total ?? "-";
                            return (
                                <React.Fragment key={g.name}>
                                    <tr>
                                        <td>P1</td>
                                        <td>{p1[0] ?? "-"}</td>
                                        <td>{p1[1] ?? "-"}</td>
                                        <td>{p1[2] ?? "-"}</td>
                                        <td>{p1[3] ?? "-"}</td>
                                        <td rowSpan={2} style={{verticalAlign: "middle"}}>
                                            {total}
                                        </td>
                                        <td rowSpan={2} style={{verticalAlign: "middle"}}>
                                            {g.name}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>P2</td>
                                        <td>{p2[0] ?? "-"}</td>
                                        <td>{p2[1] ?? "-"}</td>
                                        <td>{p2[2] ?? "-"}</td>
                                        <td>{p2[3] ?? "-"}</td>
                                    </tr>
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </Table>
            ) : (
                <>
                    <div className="mb-2">
                        <strong>Detected keys:</strong> {parsedKeys ? parsedKeys.join(", ") : "(not a JSON object)"}
                    </div>
                    <Form.Control
                        as="textarea"
                        value={pretty}
                        readOnly
                        rows={12}
                        style={{fontFamily: "monospace", whiteSpace: "pre"}}
                    />
                </>
            )}
        </>
    );
};
export default TableParamsDD;
